import { registerErrorMessage } from '@skynet/data-ws-core';
import type { JsonFailure } from '@skynet/data-ws-core';
import { searchArchivedLoans, searchArchivedRetainers, showLoan, showRetainer } from './actions';
import { createArchiveSlice } from './factory';
import { LoanArchiveCommands, RetainerArchiveCommands } from './types';

// `message` is optional on the failure envelope, so every description below
// falls back to an empty string rather than rendering the word "undefined".
registerErrorMessage(LoanArchiveCommands.SearchArchivedLoans, {
  title: 'Archived Loans Error',
  getDescription: (json: JsonFailure) => json.message ?? '',
});

registerErrorMessage(LoanArchiveCommands.ShowLoan, {
  title: 'Restore Loan Error',
  getDescription: (json: JsonFailure) => json.message ?? '',
});

registerErrorMessage(RetainerArchiveCommands.SearchArchivedRetainers, {
  title: 'Archived Retainers Error',
  getDescription: (json: JsonFailure) => json.message ?? '',
});

registerErrorMessage(RetainerArchiveCommands.ShowRetainer, {
  title: 'Restore Retainer Error',
  getDescription: (json: JsonFailure) => json.message ?? '',
});

const loansArchiveSlice = createArchiveSlice({
  prefix: 'loans',
  commands: {
    ArchivedItems: LoanArchiveCommands.ArchivedLoans,
    SearchArchivedItems: LoanArchiveCommands.SearchArchivedLoans,
    ShowItem: LoanArchiveCommands.ShowLoan,
  },
  searchAction: searchArchivedLoans,
  restoreAction: showLoan,
});

const retainersArchiveSlice = createArchiveSlice({
  prefix: 'retainers',
  commands: {
    ArchivedItems: RetainerArchiveCommands.ArchivedRetainers,
    SearchArchivedItems: RetainerArchiveCommands.SearchArchivedRetainers,
    ShowItem: RetainerArchiveCommands.ShowRetainer,
  },
  searchAction: searchArchivedRetainers,
  restoreAction: showRetainer,
});

export const loansArchiveActions = loansArchiveSlice.actions;
export const loansArchiveReducer = loansArchiveSlice.reducer;
export const retainersArchiveActions = retainersArchiveSlice.actions;
export const retainersArchiveReducer = retainersArchiveSlice.reducer;
